import type { ReactNode } from "react";
import {
  Tooltip,
  TooltipContent,
  TooltipProvider,
  TooltipTrigger,
} from "@/components/ui/tooltip";
import { useDetailField } from "./hooks/useDetailField";

export interface DetailFieldProps {
  field: string;
  isVisible?: boolean;
  value?: ReactNode;
  label?: string;
  labelKey?: string;
  tooltip?: string;
}

export function DetailField({
  field,
  isVisible = true,
  value: valueProp,
  label: labelProp,
  labelKey,
  tooltip,
}: DetailFieldProps) {
  if (!isVisible) return null;

  const { label, value } = useDetailField({
    field,
    value: valueProp,
    label: labelProp,
    labelKey,
  });

  return (
    <div className="detail-field-root">
      <span className="detail-field-label">{label}:</span>
      {tooltip ? (
        <TooltipProvider>
          <Tooltip>
            <TooltipTrigger asChild>
              <div className="detail-field-value cursor-help">{value}</div>
            </TooltipTrigger>
            <TooltipContent>{tooltip}</TooltipContent>
          </Tooltip>
        </TooltipProvider>
      ) : (
        <div className="detail-field-value">{value}</div>
      )}
    </div>
  );
}
